import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fa from "./languages/fa.json";
import en from "./languages/en.json";
import settingsFa from "./languages/settingsFa.json";
import settingsEn from "./languages/settingsEn.json";
import reportsFa from "./languages/reportsFa.json";
import reportsEn from "./languages/reportsEn.json";
import surveyFa from "./languages/surveyFa.json";
import surveyEn from "./languages/surveyEn.json";
import incentivesFa from "./languages/incentivesFa.json";
import incentivesEn from "./languages/incentivesEn.json";
import offersFa from "./languages/offersFa.json";
import offersEn from "./languages/offersEn.json";
import contentStudioFa from "./languages/contentStudioFa.json";
import contentStudioEn from "./languages/contentStudioEn.json";

const resources = {
    fa: {
        translation: {
            ...fa,
            ...settingsFa,
            ...reportsFa,
            ...surveyFa,
            ...incentivesFa,
            ...offersFa,
            ...contentStudioFa,
        },
    },
    en: {
        translation: {
            ...en,
            ...settingsEn,
            ...reportsEn,
            ...surveyEn,
            ...incentivesEn,
            ...offersEn,
            ...contentStudioEn,
        },
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: process.env.NODE_ENV === "development",
        resources,
        lng: "fa",
        fallbackLng: ["fa", "en"],
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
